import { Box } from '@chakra-ui/layout';
import { useState } from 'react';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import useCheckLogin from '../../../hook/useCheckLogin';
import UseGetGameBoxBackPathV2 from '../../../hook/useGetGameBoxBackPath_v2';
import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';
import useGames from '../useGames';

const PCToolTab = ({ hiddenHeader, setHiddenHeader }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const [dragStartTime, setDragStartTime] = useState(0);
  const { isMachineUser } = useCheckLogin();

  const navigate = useNavigate();
  const getPrevPath = UseGetGameBoxBackPathV2();
  const { to } = useParams();
  const gameConfig = useSelector((state) => state.isGameConfig);
  const { game_platform, gameCode, game_subtype, SubPlatformEnum } =
    gameConfig || {};

  const handleStart = () => {
    setDragStartTime(Date.now());
  };

  const { handleExitGame } = useGames();

  const handleStop = () => {
    if (Date.now() - dragStartTime < 200) {
      if (isMachineUser) {
        // navigate(`/${getPrevPath}/category/${SubPlatformEnum || to}/AllGames`);
        handleExitGame();
      } else {
        setHiddenHeader(false);
      }
    }
  };

  const isMachineLandscape = useIsLandScapeMachine();

  return (
    hiddenHeader && (
      <Draggable onStart={handleStart} onStop={handleStop}>
        <Box
          position={'absolute'}
          bgImage={`linear(to-b,#AD8D70,#E3D4BA,#7C6150)`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          left={'0px'}
          top={isMachineLandscape ? 'unset' : '0px'}
          bottom={isMachineLandscape ? '0px' : 'unset'}
          minW={'48px'}
          h={'52px'}
          rounded={'5px'}
          gap={'10px'}
          alignItems={'center'}
          justifyContent={'center'}
          cursor="pointer"
          className={`!flex`}
          zIndex={999999}
          sx={{
            '& > *': {
              color: 'text-yellow-500'
            }
          }}
        >
          {' '}
          {/* <IoIosArrowForward className="text-2xl" /> */}
          {i18n('leave')}
        </Box>
      </Draggable>
    )
  );
};

export default PCToolTab;
